import { css } from '@emotion/react';
import getBrowserFingerprint from 'get-browser-fingerprint';
import React, { useRef, useState } from 'react';
import { IoMdKey } from 'react-icons/io';
import { TbKey, TbUser } from 'react-icons/tb';
import { ClipLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import { useAuth } from '../../../hooks/useAuth';
import ReCAPTCHA from "react-google-recaptcha";
import './Style.css';

const LoginArea = () => {
  const {
    loginLoader,
    login,
    login2FA,
    firstLoginPass,
    phone,
    setFirstLoginPass,
  } = useAuth();

  const [token2fa, setToken2fa] = useState('');
  const [cpf, setCpf] = useState('');
  const [password, setPassword] = useState('');

  const fingerprint = getBrowserFingerprint();

  const recaptchaRef = useRef(null);

  const override = css`
    display: block;
    width: 30px !important;
    height: 30px !important;
    left: 10px !important;
    top: -5px !important;
    position: absolute;
  `;

  async function handleLogin() {
    const captchaToken = recaptchaRef.current.getValue()

    if (cpf !== '' && password !== '' && captchaToken !== '') {
      await login(cpf, password, fingerprint, captchaToken);
    } else {
      toast.error('Preencha os campos e realize o desafio do reCAPTCHA para fazer o login!');
      setPassword('');
    }
  }

  async function handle2FA() {
    if (token2fa) {
      login2FA(cpf, token2fa);
    } else {
      toast.error('Preencha os campos para fazer o login!');
    }
  }

  const returnStep = () => {
    setCpf('');
    setPassword('');
    setFirstLoginPass(false);
    setToken2fa('');
  };

  const mainLogin = () => {
    return (
      <div className='login-container'>
        <div className="input-area">
          <span>Login</span>
          <div className="input-item">
            <div className="col-md-1">
              <TbUser />
            </div>
            <div className="col-md-11">
              <input
                type="text"
                value={cpf}
                onChange={(e) => {
                  setCpf(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="input-area">
          <span>Senha</span>
          <div className="input-item">
            <div className="col-md-1">
              <TbKey />
            </div>
            <div className="col-md-11">
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <ReCAPTCHA
          theme={process.env.REACT_APP_COMPANY_THEME}
          className='recaptcha'
          ref={recaptchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        />
        <div className="button-area">
          <button onClick={handleLogin}>
            <ClipLoader
              loading={loginLoader}
              color="var(--text-primary)"
              css={override}
            />
            Acessar
          </button>
        </div>
      </div>
    );
  };

  const login2FATemplate = () => {
    return (
      <div className="login-container">
        <div className="login2FA-header">
          <h3>Autenticação de 2 fatores</h3>
          <p>Enviamos um código SMS para {phone}.</p>
        </div>

        <div className="login2FA-content">
          <div className="input-area">
            <span>Código</span>
            <div className="input-item">
              <div className="col-md-1">
                <IoMdKey />
              </div>
              <div className="col-md-11">
                <input
                  type="text"
                  maxLength={6}
                  value={token2fa}
                  onChange={(e) => {
                    setToken2fa(
                      e.target.value
                        .replace(/[^0-9.]/g, '')
                        .replace(/(\..*?)\..*/g, '$1')
                    );
                  }}
                />
              </div>
            </div>
          </div>

          <div className="login2FA-actions">
            <button onClick={returnStep}>Voltar</button>
            <button className="button2fa" onClick={handle2FA}>
              <ClipLoader
                loading={loginLoader}
                color="var(--text-primary)"
                css={override}
              />
              Entrar
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (firstLoginPass) {
    return login2FATemplate();
  }
  return mainLogin();
};

export default LoginArea;
